import { render, staticRenderFns } from "./SanadatList.vue?vue&type=template&id=b38e7a84&scoped=true"
import script from "./SanadatList.vue?vue&type=script&lang=js"
export * from "./SanadatList.vue?vue&type=script&lang=js"
import style0 from "./SanadatList.vue?vue&type=style&index=0&id=b38e7a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e7a84",
  null
  
)

export default component.exports